module.exports = __webpack_public_path__ + "static/media/r7s4.7bb1394c.jpg";